export const privateLabel = {
  hero: {
    title: "Özel Marka Çözümleri",
    subtitle: "Sizin Markanız, Bizim Uzmanlığımız",
    discreet: "GİZLİ.",
    precise:"HASSAS.",
    exclusive:"ÖZEL."
  },
  intro: {
    title: "Mükemmeliyetle Ortaklık",
    description: "Kapsamlı özel marka hizmetlerimizle vizyonunuzu gerçeğe dönüştürün. Onlarca yıllık uzmanlığımızı, son teknoloji tesislerle birleştirerek markanıza özel premium kahve ve içecek ürünleri üretiyoruz."
  },
  features: {
    quality: {
      title: "Kalitede Tutarlılık",
      description: "Lucendo'da kalite tutarlılığı bir vaat değil, disiplinimizdir. Her ürün, her süreç ve her detay, titiz standartlar ve incelikli işçilikle yönlendirilen, mükemmelliğe olan sarsılmaz bağlılığımızı yansıtır. Konseptten tamamlanmaya kadar, güvenilir, kalıcı ve güvene layık sonuçlar elde etmek için aynı hassasiyeti, özeni ve dürüstlüğü uyguluyoruz. Bu sarsılmaz tutarlılık, Lucendo'yu tanımlayan, çalışmalarımızı yücelten ve bizi tercih edenlere kalıcı değer sunan şeydir."
    },
    transparency: {
      title: "Şeffaflık",
      description: "Lucendo'da şeffaflık, kurduğumuz her ortaklığın temelidir. Güvenin, açık iletişim, net beklentiler ve iş birliğinin her aşamasında dürüstlük yoluyla kazanıldığına inanıyoruz. Görüşleri, kararları ve ilerlemeyi belirsizlik olmadan paylaşarak, karşılıklı saygı ve güvene dayalı ortaklıklar oluşturuyoruz. Şeffaflığa olan bu bağlılık, uyumu sağlar, ilişkileri güçlendirir ve netlik, dürüstlük ve ortak başarıyla birlikte büyümemizi sağlar."
    },
    growth: {
      title: "Sürdürülebilir Büyüme",
      description: "Lucendo'da sürdürülebilir büyüme, bilinçli kararlar ve uzun vadeli vizyonla yönlendirilir. Yenilikçiliği sorumlulukla dengeleyerek, ortaklarımız, çalışanlarımız ve etkilediğimiz çevreler için kalıcı değer yaratan stratejiler geliştiriyoruz. Dayanıklı uygulamalara, etik ilerlemeye ve sürekli iyileştirmeye yatırım yaparak, büyümenin sadece ölçülebilir değil, aynı zamanda anlamlı olmasını sağlıyoruz; bugünün başarısını güçlendirirken yarının fırsatlarını da güvence altına alıyoruz."
    }
  },
  process: {
    title: "Sürecimiz",
    step1: {
      title: "Danışmanlık",
      description: "Vizyonunuzu ve gereksinimlerinizi anlıyoruz"
    },
    step2: {
      title: "Geliştirme",
      description: "Uzmanlarımız size özel mükemmel harmanı oluşturur"
    },
    step3: {
      title: "Üretim",
      description: "Son teknoloji tesislerimiz kaliteyi garanti eder"
    },
    step4: {
      title: "Teslimat",
      description: "Belirlediğiniz kriterlere uygun, zamanında teslimat"
    }
  },
  cta: {
    title: "Özel Marka Yolculuğunuza Başlamaya Hazır mısınız?",
    button: "Bugün Bizimle İletişime Geçin"
  }
};